module.exports = __webpack_public_path__ + "img/sad.bfa64904.gif";